import { Title } from '@mantine/core';
import { useInputState } from '@mantine/hooks';
import { InlineEdit } from '@vision/ui/components';

interface FilterTitleInputProps {
  title: string;
  handleOnUpdateFilterName: (name: string) => void;
  loading: boolean;
  className?: string;
}

export function FilterTitleInput({ title, handleOnUpdateFilterName, loading, className }: FilterTitleInputProps) {
  const [value, setValue] = useInputState(title);

  const handleOnBlur = () => {
    handleOnUpdateFilterName(value);
  };

  return (
    <InlineEdit
      data-testid="saved-filter-name"
      value={value}
      onBlur={handleOnBlur}
      disabled={loading}
      onChange={setValue}
      iconClassName={className}
    >
      <Title fw="500" fz="12" p={0} title={value}>
        {value}
      </Title>
    </InlineEdit>
  );
}
